/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React, { useEffect, useState } from 'react';
import { useQueryParams, ArrayParam, StringParam } from 'use-query-params';
import CompanyNavBar, { navLinks } from '../../components/CompanyNavBar';
import saveFavourite from '../../lib/api/saveFavourite';
import { useAuth } from '../../commons/Auth';
import HumanResourcesFilters from '../../components/HumanResources/HumanResourcesFilters';
import { THumanResourcesFilters } from '../../components/HumanResources/human-resources';
import HumanResourcesList from '../../components/HumanResources/HumanResourcesList';
import useHumanResources from '../../lib/hooks/useHumanResources';
import useHumanResourceMutation from '../../lib/hooks/useHumanResourceMutation';
import unlockProfile from '../../lib/api/unlockProfile';
import useMe from '../../lib/hooks/useMe';
import FullScreenSpinner from '../../components/FullScreenSpinner';

const Favorites: React.FC = function Favorites() {
  const { token }: any = useAuth();
  const [query, setQuery] = useQueryParams({
    bucket: StringParam,
    eta: StringParam,
    luogoLavoro: StringParam,
    residenza: StringParam,
    occupazione: StringParam,
    titoloStudio: StringParam,
    esperienza: StringParam,
    mobilita: StringParam,
    automunito: StringParam,
    incentivi: StringParam,
    qualifica: StringParam,
    aree_di_competenza: ArrayParam,
    settori: ArrayParam,
    categoriaProtetta: StringParam,
  });

  useMe(token);
  const { data: users, isLoading } = useHumanResources({ ...query, favourites: true }, token);
  const { mutate: mutateFavourite } = useHumanResourceMutation(saveFavourite);
  const { mutate: mutateUnlockeds, isLoading: isLoadingUnlock } = useHumanResourceMutation(unlockProfile);

  const [filters, setFilters] = useState<THumanResourcesFilters>({ ...query });
  useEffect(() => setFilters({ ...query }), [query]);

  return (
    <div>
      <CompanyNavBar navLink={navLinks.favorites} />
      <div>
        <HumanResourcesFilters filters={filters} onFilter={setQuery} />
        {(isLoading || isLoadingUnlock) && <FullScreenSpinner />}
        {!isLoading && !isLoadingUnlock && users && users.length > 0 ? (
          <HumanResourcesList
            users={users}
            onFavourite={(data: any) => mutateFavourite({ ...data, token })}
            onUnlock={(data: any) => mutateUnlockeds({ ...data, token })}
          />
        ) : (
          <div className="text-center mt-36">
            <h1>Nessun utente trovato</h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;